import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
import { PrivySignInButton } from "./providers/privy/PrivySignInButton";
export const SignInButton = forwardRef((props, ref) => {
    return (_jsx(PrivySignInButton, { ...props, ref: ref, children: "Sign In" }));
});
